export default {
  getCareworkerByName: (state) => (inputValue) => {
    return state.careworkers.filter(careworker => {
      var familyNameResult = null
      var nameResult = null
      var pronunciationResult = null
      var postNameResult = null
      var jobResult = null
      var positionResult = null
      if (careworker.familyName !== null) {
        familyNameResult = careworker.familyName.match(inputValue)
      }
      if (careworker.name !== null) {
        nameResult = careworker.name.match(inputValue)
      }
      if (careworker.pronunciation !== null) {
        pronunciationResult = careworker.pronunciation.match(inputValue)
      }
      if (careworker.postName !== null) {
        postNameResult = careworker.postName.match(inputValue)
      }
      if (careworker.job !== null) {
        jobResult = careworker.job.match(inputValue)
      }
      if (careworker.position !== null) {
        positionResult = careworker.position.match(inputValue)
      }
      if (familyNameResult !== null || nameResult !== null ||
        pronunciationResult !== null || postNameResult !== null ||
        jobResult !== null || positionResult !== null) {
        var result = careworker.familyName + careworker.name + careworker.pronunciation + careworker.postName + careworker.job + careworker.position
        return result.match(inputValue)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/careworkerModules/getters.js